import _ from 'lodash';

const wrap = (Highcharts) => {
  Highcharts.setOptions({
    chart: {
      events: {
        redraw() {
          if (typeof _.get(this, 'options.chart.events.redraw') === 'function') {
            this.options.chart.events.redraw(this);
          }
        },
      },
    },
  });
};

export default wrap;
